module.exports = __webpack_public_path__ + "static/brand-210fcc51c4ae6c698268d4a921970e5e.jpg";